import { Component, Inject, OnInit, Optional } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { EtapaService } from 'src/app/services/etapa.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { Etapa } from 'src/app/models/etapa';
import { EtapaPedido } from 'src/app/models/etapa-pedido';
import { StatusDaEtapa } from 'src/app/models/enum';
import { EtapaPedidoLista } from 'src/app/models/etapa-pedido-lista';
import { PedidoLista } from 'src/app/models/pedido-lista';
import { PedidoService } from 'src/app/services/pedido.service';
import swal from 'sweetalert2';
import { GlobalService } from 'src/app/services/global.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material';
import { TagHistoricoModalComponent } from 'src/app/modals/tag-historico-modal/tag-historico-modal.component';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { tryCatch } from 'rxjs/internal-compatibility';
import { CadastrarPendenciaModalComponent } from 'src/app/modals/cadastrar-pendencia-modal/cadastrar-pendencia-modal.component';
import { ListaPendenciaModalComponent } from 'src/app/modals/lista-pendencia-modal/lista-pendencia-modal.component';

declare const $: any;

@Component({
  selector: 'app-etapas-do-pedido',
  templateUrl: './etapas-do-pedido.component.html',
  styleUrls: ['./etapas-do-pedido.component.scss']
})
export class EtapasDoPedidoComponent implements OnInit {
  idCupom: string;
  etapas: Etapa[];
  historico: EtapaPedidoLista[];
  StatusDaEtapa = StatusDaEtapa;
  integrador = false;
  texto = '';
  public config: PerfectScrollbarConfigInterface = {};
  modal = false;

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService, private globalService: GlobalService,
    private etapaService: EtapaService, private router: Router, private carregandoService: CarregandoService, private dialog: MatDialog,
    @Optional() public dialogRef: MatDialogRef<EtapasDoPedidoComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {

    const currentNavigation = this.router.getCurrentNavigation();

    if (currentNavigation && currentNavigation.extras && currentNavigation.extras.state && currentNavigation.extras.state.idCupom) {
      this.idCupom = currentNavigation.extras.state.idCupom;
    } else {
      this.idCupom = data.idCupom;
      this.modal = true;
    }
  }

  async ngOnInit() {
    this.integrador = await this.globalService.integrador();

    this.texto = this.integrador ? 'Orçamento' : 'Pedido';
    this.buscarEtapasDoPedido();
    this.buscarHistoricoDoPedido();
  }

  buscarEtapasDoPedido() {
    this.carregandoService.mostra('buscaEtapas');

    this.etapaService.consultarPorIdCupom(this.idCupom).subscribe(ets => {
      this.etapas = ets;
      this.carregandoService.esconde('buscaEtapas');
    }, (erro) => {
      this.carregandoService.esconde('buscaEtapas');
      this.notificacaoService.erro(erro);
    });
  }

  buscarHistoricoDoPedido() {
    this.carregandoService.mostra('buscaHistoricoEtapas');

    this.etapaService.consultarHistoricoPorIdCupom(this.idCupom).subscribe(ets => {
      this.historico = ets;
      this.carregandoService.esconde('buscaHistoricoEtapas');
    }, (erro) => {
      this.carregandoService.esconde('buscaHistoricoEtapas');
      this.notificacaoService.erro(erro);
    });
  }

  alterarEtapa(etapa: Etapa) {
    if (etapa.status !== StatusDaEtapa.EmAndamento || this.integrador || this.etapas.some(p => p.status === StatusDaEtapa.Cancelamento) || etapa.ordem === 1 || etapa.ordem === 2) {
      return;
    }

    swal({
      title: 'Atenção!!',
      text: 'Deseja realmente concluir a etapa?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonClass: 'btn btn-info',
      cancelButtonClass: 'btn btn-danger',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Não',
      buttonsStyling: false
    }).then((result) => {
      if (result.value) {
        this.carregandoService.mostra('salvaHistoricoEtapas');

        const historico = new EtapaPedido();
        historico.idEtapa = etapa.id;
        historico.idCupom = this.idCupom;

        this.etapaService.salvarHistorico(historico).subscribe(resp => {
          this.carregandoService.esconde('salvaHistoricoEtapas');
          this.buscarEtapasDoPedido();
          this.buscarHistoricoDoPedido();
        }, (erro) => {
          this.carregandoService.esconde('salvaHistoricoEtapas');
          this.notificacaoService.erro(erro);
        });
      }
    });
  }

  podeVisualizarLog(log: EtapaPedidoLista): boolean {
    if (this.integrador) {
      if (this.etapas) {
        const etapa = this.etapas.find(e => e.id === log.idEtapa);
        return etapa ? etapa.visualizaIntegrador : false;
      }
      return false;
    }
    return true;
  }

  voltar() {
    this.dialogRef.close();
  }
}
